import { formatCents } from './general.ts'

/**
 * The one line the billing panel prints about the Stripe customer balance (router#1315).
 *
 * ⚠⚠ STRIPE'S SIGN, NOT OURS. `customer.balance` is NEGATIVE when Stripe owes the customer and
 * POSITIVE when the customer owes Stripe — the opposite of how a person reads "balance". The
 * router serves the integer unchanged as `customer_balance_cents`, so the flip happens HERE, once,
 * and the caller never compares the sign itself.
 *
 * Measured 2026-09-06 (router#1315): a Business-annual → Pro-annual downgrade two minutes after
 * checkout left the customer owed $1,800, and no surface — portal, `/billing`, `/usage` — showed
 * it. With the portal on `always_invoice` the proration is invoiced at once and the credit lands
 * on `customer.balance` as `-180000`, which is what this prints.
 *
 * Returns null for nothing to say: zero, an absent field (a router that predates router#1315),
 * and anything that is not an integer — the router promises one, and a fraction of a cent is a
 * contract broken somewhere rather than an amount to format.
 */
export const balanceLine = (cents: number | null): string | null => {
  if (cents === null || !Number.isInteger(cents) || cents === 0) return null
  if (cents < 0) return `${formatCents(-cents)} credit on your account, applied to your next invoices.`
  return `${formatCents(cents)} outstanding on your account — it is added to your next invoice.`
}
